import React from "react";
import { Field, FieldProps, getIn } from "formik";
import BareInput, { BareInputProps } from "./BareInput";

// ─── InputFormField ───────────────────────────────────────────────────────────

export type InputFormFieldExtraProps = {
  name: string;
  hideError?: boolean;
  showErrorOnceTouched?: boolean;
};

export type InputFormFieldProps = BareInputProps & InputFormFieldExtraProps;

const InputFormField = React.forwardRef<HTMLInputElement, InputFormFieldProps>(
  (
    {
      name,
      hideError,
      showErrorOnceTouched,
      variant,
      onChange,
      helperText,
      ...props
    },
    ref
  ) => {
    return (
      <Field name={name}>
        {({
          field,
          form: { touched, errors, validateOnChange },
        }: FieldProps) => {
          let hasError = Boolean(getIn(errors, name) && getIn(touched, name));
          if (validateOnChange && !showErrorOnceTouched) {
            hasError = Boolean(getIn(errors, name));
          }

          const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            field.onChange(e);
            onChange?.(e);
          };
          const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
            field.onBlur(e);
            props.onBlur?.(e);
          };

          return (
            <BareInput
              ref={ref}
              {...props}
              name={name}
              variant={hasError ? "error" : variant}
              helperText={
                !hideError && hasError ? getIn(errors, name) : helperText
              }
              value={field.value}
              onChange={handleChange}
              onBlur={handleBlur}
            />
          );
        }}
      </Field>
    );
  }
);

InputFormField.displayName = "InputFormField";

export default InputFormField;
